@if (!isPrintPDFRoute) {
  <div #stickyFooter class="hide-for-print floating-footer">
    <p class="floating-footer__paragraph" [innerText]="'Hide figures?' | translate"></p>
    <core-toggle-figures [isFloatingToggle]="true"></core-toggle-figures>
    <a [innerText]="'Logout' | translate" [routerLink]="'/logout'" class="btn btn--logout btn--logout-footer"
    href="#"></a>
  </div>
}
